import * as React from 'react';
import { Alert, AlertType } from './alert';

interface IErrorBoundaryState {
  hasError: boolean;
  error: {
    name: string;
    message: string;
    stack: string;
  };
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<Object>, IErrorBoundaryState> {
  constructor(props: React.PropsWithChildren<Object>) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({
      ...this.state,
      error: {
        name: error.name,
        message: error.message,
        stack: errorInfo.componentStack
      }
    });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      if (this.state.error) {
        // You can render any custom fallback UI
        const { name, message, stack } = this.state.error;
        return (
          <Alert type={AlertType.Error}>
            <div className='font-weight-bold'>{name}</div>
            <div>{message}</div>
            <div>{stack}</div>
          </Alert>
        );
      } else {
        return <Alert type={AlertType.Error}>Something went wrong!</Alert>;
      }
    }

    return <>{this.props.children}</>;
  }
}
